<script setup>
import { ref, computed, defineProps } from 'vue';

// Vue Components
import NewsList from './NewsList.vue';
import NewsCategories from './NewsCategories.vue';
import NewsPagination from './NewsPagination.vue';
import Loading from './Loading.vue';

// Functions
import getNewsCategories from '../functions/getNewsCategories.js';
import getNewsList from '../functions/getNewsList.js';

const props = defineProps({
    rootPath: {
        type: String,
        default: ''
    },
});

// 定数
const perPage = 12; //1ページの記事数
const taxonomy = 'news_cat'; //タクソノミー名

// URLパラメータを取得
const params = new URL(window.location.href).searchParams;
const catParam = params.get('category'); //カテゴリ
const pageParam = params.has('page') ? params.get('page') - 0 : 1; //ページ

// リアクティブデータ
const categories = ref([]); //カテゴリ一覧
const posts = ref([]); //記事一覧
const total = ref(0); //トータルの記事件数
const errorFlug = ref(false); //エラーかどうか
const done = ref(false); //全ての処理が終わったかどうか

/*--------------------------------------------
    カテゴリ関連
--------------------------------------------*/

// 現在のカテゴリIDをURLパラメータから検索
const currentCatId = computed(() => {
    if (!catParam) return; //カテゴリ一覧ではない場合０を返す

    for (const val of categories.value) {
        if(val.slug !== catParam) continue;
        return val.id;
    }
});

/*--------------------------------------------
    ページネーション関連
--------------------------------------------*/

// 全体のページ数
const totalPage = computed(() => {
    return Math.ceil(total.value / perPage);
});

// 取得済の記事件数をページ数から計算
const offset = computed(() => {
    return  perPage * (pageParam - 1);
});

// ページ数が全体のページ数を超えていたら1ページ目に遷移
const redirectWhenPageOver = () => {
    if (pageParam !== 1 && pageParam > totalPage.value) window.location.href = "/news/";
}

/*--------------------------------------------
    各情報を取得
--------------------------------------------*/

try {
    // カテゴリを取得
    categories.value = await getNewsCategories(props.rootPath, taxonomy);
    
    // 記事情報を取得
    const postsData = await getNewsList(props.rootPath, perPage, taxonomy, currentCatId.value, offset.value);
    total.value = postsData.totalNum;
    posts.value = postsData.postsList.length ? posts.value.concat(postsData.postsList) : 'noposts';
    done.value = true;
    
} catch(error) {
    //例外処理
    errorFlug.value = true;
    
} finally {
	//例外の有無に関わらず最後に必ず実行
    redirectWhenPageOver();
}

</script>

<template>
<!-- sec -->
<section class="sec wow animate__fadeIn" v-if="done">
    <div class="inner is-small">
        <div class="sec__area">
            <NewsCategories
            :categories="categories"
            :currentCatSlug="catParam ? catParam : 'all'"/>

            <NewsList
            v-if="!errorFlug"
            :taxonomy="taxonomy"
            :categories="categories"
            :posts="posts"/>
            <p v-else>読み込みに失敗しました。</p>

        </div>

        <NewsPagination
        :totalPage="totalPage"
        :perPage="perPage"
        :currentPage="pageParam"
        :currentCat="catParam"/>

    </div>
</section><!-- ./sec -->
<Loading v-else/>
</template>